import React, { useMemo } from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS, CategoryScale, LinearScale, BarElement, Tooltip, Legend,
} from "chart.js";
import "./DashboardComponents.css";

// Phase 5, §31. Reuses the SAME chart.js registration/options convention
// already established in src/pages/technicians/TechnicianDashboard.js —
// no new charting approach introduced. Frontend never calculates the
// values shown; `data` is always the backend-returned breakdown.
ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

const CHART_COLORS = ["#f59e0b", "#0ea5e9", "#22c55e", "#64748b", "#ef4444", "#8b5cf6", "#14b8a6", "#ff6b35", "#06b6d4", "#84cc16"];

export default function MetricTrendChart({ title, labels, values }) {
  const data = useMemo(() => ({
    labels: labels || [],
    datasets: [{
      label: title,
      data: values || [],
      backgroundColor: (labels || []).map((_, i) => CHART_COLORS[i % CHART_COLORS.length]),
      borderRadius: 4,
    }],
  }), [title, labels, values]);

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: { legend: { display: false } },
    scales: { y: { beginAtZero: true } },
  };

  if (!labels || labels.length === 0) {
    return (
      <div className="perf-empty-state">
        <i className="fa-solid fa-chart-column" aria-hidden="true"></i>
        <p>No data available for this selection.</p>
      </div>
    );
  }

  return (
    <div className="perf-trend-chart">
      <Bar data={data} options={options} />
    </div>
  );
}
